const constants = {
  ADD_FOOTER_NOTIFICATION: 'ADD_FOOTER_NOTIFICATION',
  DELETE_FOOTER_NOTIFICATION: 'DELETE_FOOTER_NOTIFICATION',
  ADD_SNACKBAR_NOTIFICATION: 'ADD_SNACKBAR_NOTIFICATION',
  DELETE_SNACKBAR_NOTIFICATION: 'DELETE_SNACKBAR_NOTIFICATION',
  ADD_DIALOG_ERROR_NOTIFICATION: 'ADD_DIALOG_ERROR_NOTIFICATION',
  DELETE_DIALOG_ERROR_NOTIFICATION: 'DELETE_DIALOG_ERROR_NOTIFICATION',
};

export default constants;
